var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicenceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5 0H2.7C1.2 0 0 1.2 0 2.7V17.3C0 18.8 1.2 20 2.7 20H26.5C28 20 29.2 18.8 29.2 17.3V2.7C29.1 1.2 27.9 0 26.5 0ZM27.5 17.3C27.5 17.9 27 18.3 26.5 18.3H2.7C2.1 18.3 1.7 17.8 1.7 17.3V2.7C1.7 2.1 2.2 1.7 2.7 1.7H26.5C27.1 1.7 27.5 2.2 27.5 2.7V17.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7 13.9H11.4C11.8 13.9 12.1 13.6 12.1 13.2C12.1 12.8 11.8 12.5 11.4 12.5H4.7C4.3 12.5 4 12.8 4 13.2C4.1 13.6 4.4 13.9 4.7 13.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7 7.4H11.4C11.8 7.4 12.1 7.1 12.1 6.7C12.1 6.3 11.8 6 11.4 6H4.7C4.3 6 4 6.3 4 6.7C4.1 7.1 4.4 7.4 4.7 7.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69961 10H9.39961C9.79961 10 10.0996 9.70001 10.0996 9.30001C10.0996 8.90001 9.79961 8.60001 9.39961 8.60001H4.69961C4.39961 8.70001 4.09961 9.00001 4.09961 9.30001C4.09961 9.70001 4.39961 10 4.69961 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4992 9.00001L23.5992 5.60001C23.4992 5.30001 23.1992 5.20001 22.7992 5.20001H17.8992C17.4992 5.20001 17.1992 5.40001 16.9992 5.70001L15.1992 9.00001V13.9C15.1992 14.4 15.5992 14.8 16.1992 14.8C16.6992 14.8 17.1992 14.4 17.1992 13.9V13.3H23.4992V13.9C23.4992 14.4 23.8992 14.8 24.4992 14.8C24.9992 14.8 25.4992 14.4 25.4992 13.9V9.00001ZM17.6992 8.30001L18.4992 6.90001H18.5992H22.3992V7.00001L23.1992 8.40001H22.9992H22.8992H17.6992V8.30001ZM23.6992 11.7H23.5992H17.0992V11.6V10H17.1992H23.6992V10.1V11.7Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.1,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenceIcon);
export default __webpack_public_path__ + "static/media/licence-icon.2650cdca8d0361515b8eb7690b43ddad.svg";
export { ForwardRef as ReactComponent };